import { SearchResults } from '../../../types';

export function calculateHeightStyle(results: SearchResults) {
	const minimumResultsetHeight = 2.5;
	const maxItemHeight = 50;
	const maxHeaderHeight = 40;
	const bottomOffeset = 50;

	const totalGroups = Object.keys(results).reduce((acc, key) => {
		const items = results[key as keyof SearchResults];
		const itemsLength = Array.isArray(items) ? items.length : items?.total;
		const hasItems = itemsLength > 0;

		return acc + (hasItems ? 1 : 0);
	}, 0);

	if (totalGroups === 0) {
		return;
	}

	const totalHeadersHeight = maxHeaderHeight * totalGroups;
	const topOffset = document.querySelector('.nav-bar-searchbox')?.getClientRects()?.[0]?.top || 0;
	const remainingHeight = window.innerHeight - topOffset - bottomOffeset - totalHeadersHeight;
	const maxHeight = Math.floor(remainingHeight / totalGroups);
	const minHeight = Math.floor(maxItemHeight * minimumResultsetHeight);

	return { minHeight: 'auto', maxHeight: `${Math.max(maxHeight, minHeight)}px` };
}
